/**
 * ч.766: призначення зарплатної платіжки з посиланням на платіжки податків —
 * ДЗЕРКАЛО backend `services/bank_tax_links.py:purpose_with_tax_links`.
 * «Виплата заробітної плати за 08.2026. ПДФО, ВЗ та ЄСВ сплачено п/і № 1, 2, 3 від 09.09.2026»
 */
export type TaxLinkType = 'PDFO' | 'WZ' | 'ESV';
export const TAX_LINK_TYPES: TaxLinkType[] = ['PDFO', 'WZ', 'ESV'];
export const TAX_LINK_LABEL: Record<TaxLinkType, string> = { PDFO: 'ПДФО', WZ: 'ВЗ', ESV: 'ЄСВ' };

const SUFFIX_RE = /\.?\s*(?:ПДФО|ВЗ|ЄСВ)(?:,\s*(?:ПДФО|ВЗ|ЄСВ))*(?:\s+та\s+(?:ПДФО|ВЗ|ЄСВ))?\s+сплачено п\/і [\s\S]*$/;

export interface TaxLinkRef { tax_type: TaxLinkType; document_number: string; document_date: string | null }

const fmtDate = (d: string | null) => (d ? new Date(d).toLocaleDateString('uk-UA') : '');

export function purposeWithTaxLinks(basePurpose: string, links: TaxLinkRef[]): string {
  const base = basePurpose.replace(SUFFIX_RE, '').trim().replace(/[.\s]+$/, '');
  if (links.length === 0) return base;
  const labels = links.map((l) => TAX_LINK_LABEL[l.tax_type]);
  const taxes = labels.length > 1 ? `${labels.slice(0, -1).join(', ')} та ${labels[labels.length - 1]}` : labels[0];
  const dates = new Set(links.map((l) => fmtDate(l.document_date)));
  const tail = dates.size === 1
    ? `№ ${links.map((l) => l.document_number).join(', ')} від ${[...dates][0]}`
    : links.map((l) => `№ ${l.document_number} від ${fmtDate(l.document_date)}`).join(', ');
  return base ? `${base}. ${taxes} сплачено п/і ${tail}` : `${taxes} сплачено п/і ${tail}`;
}
